import { useParams } from "react-router-dom";
import UtilityListPage from "./list/UtilityListPage";
import UtilityDetailPage from "./detail/UtilityDetailPage";
import "./utilities.css";

const Utilities = () => {
  const { id } = useParams();
  return id ? <UtilityDetailPage /> : <UtilityListPage />;
};

export default Utilities;
